import { queryOptions } from '@tanstack/vue-query'
import merge from 'lodash/merge'
import { queryClient } from '@/plugins/tanstack'
import { getSkillsV2 } from '@/common/services/SkillsService'
import localizationServerData from '@/common/services/serverData/localizationServerData'
import { invalidateQuery, queryKeyFactory } from '@/common/services/serverData/serverDataManager'
import { SERVER_DATA_LABELS, SERVER_DATA_SCOPE, type FetchOptionBase } from '@/common/types/cacheConstants'

function groupOptions() {
  return queryOptions({
    queryKey: queryKeyFactory({
      scope: SERVER_DATA_SCOPE.SKILLS,
    }),
    staleTime: Infinity,
    queryFn: getSkillsV2,
  })
}

async function fetch(options: FetchOptionBase = {}) {
  const { staleTime } = options
  const [result] = await Promise.all([
    queryClient.fetchQuery(merge(groupOptions(), { staleTime })),
    localizationServerData.fetch({
      prefixes: SERVER_DATA_LABELS.SKILLS,
      staleTime,
    }),
  ])
  return result
}

function invalidate() {
  invalidateQuery([
    queryKeyFactory({
      scope: SERVER_DATA_SCOPE.SKILLS,
    }),
  ])
}

export default {
  fetch,
  groupOptions,
  invalidate,
}
